import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bf22a99a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bf22a99a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf22a99a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf22a99a')) {
      api.createRecord('bf22a99a', component.options)
    } else {
      api.reload('bf22a99a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bf22a99a&scoped=true", function () {
      api.rerender('bf22a99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/password-validator/index.vue"
export default component.exports